import { Box, styled } from '@mui/material';

export const MapContainer = styled(Box)(({ theme }) => ({
  '& > div': {
    borderRadius: theme.spacing(2),
    boxShadow: theme.shadows[5],
  },
}));
